<template>
  <div class="withdraw-records-page">
    <van-nav-bar 
      :left-arrow="true" 
      left-text="返回" 
      title="提现记录" 
      fixed 
      :placeholder="true" 
      @click-left="goBack" 
    />
    
    <!-- 记录列表 -->
    <div class="records-list">
      <div v-if="records.length === 0" class="empty-state">
        <div class="empty-icon">📋</div>
        <div class="empty-text">暂无提现记录</div>
      </div>
      
      <div v-else class="record-items">
        <div 
          v-for="item in records" 
          :key="item.ID" 
          class="record-item"
        >
          <div class="record-header">
            <div class="record-info">
              <div class="record-id">申请号：{{ item.ID }}</div>
              <div class="record-time">{{ formatTime(item.CreatedAt || item.created_at) }}</div>
            </div>
            <div class="record-amount">¥{{ item.amount }}</div>
          </div>
          
          <div v-if="item.receipt_kind" class="record-remark">收款：{{ item.receipt_kind === 'wechat' ? '微信' : '支付宝' }} · {{ item.receipt_name }} {{ item.account || '收款二维码' }}</div>
          <van-image v-if="item.receipt_qr_code" width="120" height="120" fit="contain" :src="item.receipt_qr_code" />
          <div v-if="item.transfer_time_text" class="record-remark">打款时间：{{ item.transfer_time_text }}</div>
          <div class="record-status">
            <div class="status-left">
              <span class="status-badge" :class="getStatusClass(item.status_text)">
                {{ item.status_text }}
              </span>
            </div>
            <div class="status-right">
              <van-button 
                size="mini" 
                type="default" 
                @click="showOrderDetails(item)"
                class="detail-btn"
              >
                明细
              </van-button>
            </div>
          </div>
          
          <div v-if="item.desc || item.remark" class="record-remark">
            <span class="remark-label">备注：</span>
            <span class="remark-text">{{ item.desc || item.remark }}</span>
          </div>
        </div>
      </div>
    </div>
    
    <!-- 订单详情弹窗 -->
    <van-popup 
      v-model="showOrderPopup" 
      position="bottom" 
      :style="{ height: '70%' }"
      round
    >
      <div class="order-details-popup">
        <div class="popup-header">
          <div class="popup-title">订单明细</div>
          <van-icon name="cross" @click="closeOrderPopup" class="close-icon" />
        </div>
        
        <div class="popup-content">
          <van-pull-refresh v-model="refresh" @refresh="onRefresh">
            <van-list
              v-model="loading"
              :finished="finished"
              finished-text="没有更多了"
              @load="onLoad"
              :immediate-check="false"
            >
              <div v-if="orderDetails.length === 0 && !loading" class="empty-orders">
                <div class="empty-icon">📋</div>
                <div class="empty-text">暂无相关订单</div>
              </div>
              
              <div v-else class="order-list">
                <div 
                  v-for="item in orderDetails" 
                  :key="item.order_id" 
                  class="order-card"
                >
                  <div class="card-top">
                    <div class="top-left">
                      <div class="cinema-name">{{ item.cinema_name }}</div>
                      <div class="order-row">
                        <span class="order-id">{{ item.order_id }}</span>
                        <span class="copy-btn" @click.stop="copyOrderId(item.order_id)">复制</span>
                      </div>
                    </div>
                    <div class="top-right">
                      <span class="status-text">已出票</span>
                      <div class="market-price">市场价:￥{{ item.channel_price }}</div>
                    </div>
                  </div>
                  
                  <div class="card-middle">
                    <div class="movie-img-box">
                      <van-image width="80px" height="100px" fit="cover" :src="item.logo+'_200x200'" />
                    </div>
                    <div class="movie-info-box">
                      <div class="movie-title-row">
                        <div class="movie-title">{{ item.movie_name }}</div>
                        <div class="city-name">{{ item.city_name }}</div>
                      </div>
                      <div class="showtime-row">
                        <span class="today-tag" v-if="item.play_date_tag">{{ item.play_date_tag }}</span>
                        <span class="showtime">{{ item.play_time_text }}</span>
                      </div>
                      <div class="hall-name" v-if="item.hall_name">{{ item.hall_name }}</div>
                      <div class="movie-tags">
                        <span class="ticket-count">{{ item.quantity }}张</span>
                        <span v-if="item.seatTag === '2'" class="seat-type-tag couple-seat">情侣座</span>
                        <span v-if="item.support_exchange_seat === 'Y'" class="seat-type-tag">九宫格换座</span>
                      </div>
                    </div>
                  </div>
                  
                  <div class="card-bottom">
                    <div class="my-bid">已报价:<span style="color: #ff2c54;font-weight: bold;">￥{{ item.my_bid_price }}</span></div>
                    <div class="status-info">
                      <span class="status-text-green">{{ item.status_text }}</span>
                    </div>
                  </div>
                </div>
              </div>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import Api from '@/api-service'

export default {
  name: "WithdrawRecords",
  data() {
    return {
      records: [],
      loading: false,
      showOrderPopup: false,
      orderDetails: [],
      currentWithdrawId: null,
      refresh: false,
      finished: false,
      queryData: {
        page: 1,
        pageSize: 10
      }
    }
  },
  created() {
    this.fetchRecords();
  },
  methods: {
    fetchRecords() {
      this.loading = true;
      Api.getWithdrawList({ id: Number(this.$route.query.id) || 0 }).then(res => {
        this.records = res.list || [];
        this.loading = false;
      }).catch(err => {
        console.error('获取提现记录失败:', err);
        this.loading = false;
        this.$toast.fail('获取记录失败');
      });
    },
    formatTime(timeStr) {
      if (!timeStr) return '';
      const date = new Date(timeStr);
      return date.toLocaleString('zh-CN', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        hour: '2-digit',
        minute: '2-digit'
      });
    },
    getStatusClass(status) {
      if (status.includes('成功') || status.includes('完成') || status.includes('已到账')) {
        return 'status-success';
      } else if (status.includes('处理中') || status.includes('审核中') || status.includes('待处理')) {
        return 'status-pending';
      } else if (status.includes('失败') || status.includes('拒绝') || status.includes('已取消')) {
        return 'status-failed';
      } else {
        return 'status-default';
      }
    },
    showOrderDetails(withdrawItem) {
      this.currentWithdrawId = withdrawItem.ID;
      this.showOrderPopup = true;
      this.fetchOrderDetails(withdrawItem.ID);
    },
    closeOrderPopup() {
      this.showOrderPopup = false;
      this.orderDetails = [];
      this.currentWithdrawId = null;
    },
    fetchOrderDetails(withdrawId) {
      this.queryData.page = 1;
      this.finished = false;
      this.orderDetails = [];
      this.fetchOrderList(withdrawId);
    },
    fetchOrderList(withdrawId) {
      const params = {
        ...this.queryData,
        withdraw_id: withdrawId
      };
      
      Api.getProcessedOrderList(params).then(res => {
        this.loading = false;
        this.refresh = false;
        
        if (res.list && res.list.length > 0) {
          res.list.forEach(item => {
            this.orderDetails.push(item);
          });
          
          if (res.list.length < this.queryData.pageSize) {
            this.finished = true;
          }
        } else {
          this.finished = true;
        }
      }).catch(err => {
        console.error('获取订单详情失败:', err);
        this.loading = false;
        this.refresh = false;
        this.$toast.fail('获取订单详情失败');
      });
    },
    onRefresh() {
      this.queryData.page = 1;
      this.finished = false;
      this.orderDetails = [];
      this.fetchOrderList(this.currentWithdrawId);
    },
    onLoad() {
      this.queryData.page++;
      this.fetchOrderList(this.currentWithdrawId);
    },
    orderDetail(id) {
      this.$router.push({path:'/order/detail',query:{id:id}})
    },
    copyOrderId(orderId) {
      if (!orderId) return;
      if (navigator && navigator.clipboard) {
        navigator.clipboard.writeText(orderId).then(() => {
          this.$toast.success('复制成功');
        }).catch(() => {
          this.$toast.fail('复制失败');
        });
      } else {
        // 兼容性处理
        try {
          const input = document.createElement('input');
          input.value = orderId;
          document.body.appendChild(input);
          input.select();
          document.execCommand('copy');
          document.body.removeChild(input);
          this.$toast.success('复制成功');
        } catch (err) {
          this.$toast.fail('复制失败');
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    }
  }
}
</script>

<style scoped lang="scss">
.withdraw-records-page {
  min-height: 100vh;
  background-color: #f8f9fa;
  padding-bottom: calc(20px + env(safe-area-inset-bottom, 0px));

  .records-list {
    padding: 16px;

    .empty-state {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      padding: 60px 20px;
      text-align: center;

      .empty-icon {
        font-size: 48px;
        margin-bottom: 16px;
        opacity: 0.6;
      }

      .empty-text {
        font-size: 16px;
        color: #7f8c8d;
        font-weight: 500;
      }
    }

    .record-items {
      .record-item {
        background: white;
        border-radius: 12px;
        padding: 16px;
        margin-bottom: 12px;
        box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
        border: 1px solid #f0f0f0;

        .record-header {
          display: flex;
          justify-content: space-between;
          align-items: flex-start;
          margin-bottom: 12px;

          .record-info {
            flex: 1;

            .record-id {
              font-size: 15px;
              font-weight: 600;
              color: #2c3e50;
              margin-bottom: 4px;
            }

            .record-time {
              font-size: 13px;
              color: #7f8c8d;
              font-weight: 400;
            }
          }

          .record-amount {
            font-size: 18px;
            font-weight: 700;
            color: #2c3e50;
            text-align: right;
          }
        }

        .record-status {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 8px;

          .status-left {
            .status-badge {
              display: inline-block;
              padding: 4px 12px;
              border-radius: 16px;
              font-size: 12px;
              font-weight: 500;
              text-align: center;

              &.status-success {
                background-color: #f6ffed;
                color: #52c41a;
                border: 1px solid #b7eb8f;
              }

              &.status-pending {
                background-color: #fffbe6;
                color: #faad14;
                border: 1px solid #ffe58f;
              }

              &.status-failed {
                background-color: #fff2f0;
                color: #ff4d4f;
                border: 1px solid #ffccc7;
              }

              &.status-default {
                background-color: #f5f5f5;
                color: #666;
                border: 1px solid #d9d9d9;
              }
            }
          }

          .status-right {
            .detail-btn {
              font-size: 11px;
              height: 24px;
              padding: 0 8px;
              border-radius: 6px;
              border: 1px solid #667eea;
              background: white;
              color: #667eea;
              font-weight: 500;
              transition: all 0.3s ease;

              &:active {
                background: rgba(102, 126, 234, 0.1);
                transform: scale(0.95);
              }
            }
          }
        }

        .record-remark {
          padding-top: 8px;
          border-top: 1px solid #f0f0f0;

          .remark-label {
            font-size: 13px;
            color: #7f8c8d;
            font-weight: 500;
          }

          .remark-text {
            font-size: 13px;
            color: #2c3e50;
            font-weight: 400;
          }
        }
      }
    }
  }

  .order-details-popup {
    height: 100%;
    display: flex;
    flex-direction: column;

    .popup-header {
      display: flex;
      justify-content: space-between;
      align-items: center;
      padding: 16px 20px;
      border-bottom: 1px solid #f0f0f0;
      background: white;

      .popup-title {
        font-size: 16px;
        font-weight: 600;
        color: #2c3e50;
      }

      .close-icon {
        font-size: 20px;
        color: #7f8c8d;
        cursor: pointer;
        padding: 4px;
        border-radius: 4px;
        transition: all 0.3s ease;

        &:active {
          background: #f5f5f5;
        }
      }
    }

    .popup-content {
      flex: 1;
      overflow-y: auto;
      padding: 16px;

      .empty-orders {
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        padding: 40px 20px;
        text-align: center;

        .empty-icon {
          font-size: 32px;
          margin-bottom: 12px;
          opacity: 0.6;
        }

        .empty-text {
          font-size: 14px;
          color: #7f8c8d;
          font-weight: 500;
        }
      }

      .order-list {
        .order-card {
          background: #fff;
          border-radius: 10px;
          box-shadow: 0 2px 8px rgba(0, 0, 0, 0.03);
          margin: 8px 8px 12px 8px;
          padding: 12px 10px 10px 10px;
          display: flex;
          flex-direction: column;
          border: 1px solid #f0f0f0;

          .card-top {
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
            margin-bottom: 8px;

            .top-left {
              .cinema-name {
                font-weight: bold;
                font-size: 15px;
                color: #222;
                text-overflow: ellipsis;
                overflow: hidden;
                white-space: nowrap;
                max-width: 100%;
                display: block;
              }

              .order-row {
                display: flex;
                align-items: center;
                font-size: 12px;
                color: #888;
                margin-top: 2px;

                .order-id {
                  margin-right: 6px;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }

                .copy-btn {
                  color: #409eff;
                  cursor: pointer;
                  font-size: 12px;
                  flex-shrink: 0;
                  padding: 2px 4px;
                  border-radius: 3px;
                  transition: all 0.3s ease;

                  &:hover {
                    background: rgba(64, 158, 255, 0.1);
                  }

                  &:active {
                    background: rgba(64, 158, 255, 0.2);
                  }
                }
              }
            }

            .top-right {
              text-align: right;
              flex-shrink: 0;

              .status-text {
                color: #52c41a;
                font-size: 13px;
                font-weight: bold;
                display: block;
              }

              .market-price {
                font-size: 12px;
                color: #888;
                margin-top: 2px;
                white-space: nowrap;
              }
            }
          }

          .card-middle {
            display: flex;
            align-items: flex-start;
            margin-bottom: 8px;

            .movie-img-box {
              width: 70px;
              height: 90px;
              border-radius: 4px;
              margin-right: 10px;
              overflow: hidden;
              flex-shrink: 0;
            }

            .movie-info-box {
              flex: 1;

              .movie-title-row {
                display: flex;
                align-items: center;
                justify-content: space-between;
                margin-bottom: 4px;

                .movie-title {
                  font-size: 14px;
                  font-weight: 500;
                  color: #333;
                  flex: 1;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  margin-right: 8px;
                }

                .city-name {
                  font-size: 12px;
                  color: #666;
                  flex-shrink: 0;
                }
              }

              .showtime-row {
                font-size: 12px;
                color: #333;
                margin-bottom: 4px;
                display: flex;
                align-items: center;
                gap: 4px;

                .today-tag {
                  display: inline-block;
                  color: white;
                  background-color: #ff2c53da;
                  font-size: 10px;
                  font-weight: bold;
                  padding: 1px 4px 1px 3px;
                  margin-right: 2px;
                  line-height: 1.2;
                  vertical-align: middle;
                  border-radius: 2px;
                  flex-shrink: 0;
                }

                .showtime {
                  color: #666;
                  flex: 1;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                }
              }

              .hall-name {
                font-size: 12px;
                color: #888;
                margin-bottom: 3px;
              }

              .movie-tags {
                margin-top: 3px;

                .ticket-count {
                  background: #f7f8fa;
                  border-radius: 6px;
                  font-size: 9px;
                  padding: 1px 3px;
                  color: #666;
                  display: inline-block;
                }

                .seat-type-tag {
                  border: 1px solid rgb(0, 140, 255);
                  color: rgb(0, 140, 255);
                  border-radius: 2px;
                  font-size: 9px;
                  font-weight: bold;
                  padding: 1px 2px;
                  margin-left: 3px;
                  display: inline-block;
                }
                
                .couple-seat {
                  border: 1px solid #ff2c54;
                  color: #ff2c54;
                  background-color: #fff2f0;
                }
              }
            }
          }

          .card-bottom {
            display: flex;
            justify-content: space-between;
            align-items: center;

            .my-bid {
              font-size: 13px;
              color: #666;
            }

            .status-info {
              .status-text-green {
                font-size: 13px;
                color: #52c41a;
                font-weight: bold;
              }
            }
          }
        }
      }
    }
  }
}
</style> 